const API_URL =
  "https://l42lyzqau0.execute-api.ap-southeast-2.amazonaws.com/Prod/send";

// curl -v -X OPTIONS https://l42lyzqau0.execute-api.ap-southeast-2.amazonaws.com/Prod

export const sendForm = async (data) => {
  console.log(data);

  const emailData = {
    toEmails: ["info@rogertompkins.com", "dev@rockcold.co.nz"],
    fromEmail: "info@rogertompkins.com",
    // "fromEmail": "RCD dev <dev@rockcold.co.nz>",
    subject: "R.M.Tompkins Guided Fishing Trips Bookings Enquiry",
    // "message": "Test <b> message</b>"
    message: buildHtml(data),
    // `
    //   Hi Roger\n\n
    //   Booking Enquiry from \n\n
    //   ${data.firstname} ${data.lastname}\n
    //   ${data.email}\n
    //   ${data.phone}\n\n
    //   Trip Details\n
    //   Date: ${data.date}\n
    //   Trip: ${data.trip}\n
    //   Accommodation: ${data.accommodation}\n
    //   Anglers: ${data.people}\n\n
    //   ---------------------------
    //   rogertompkins.com
    // `
  };
  console.log(JSON.stringify(emailData, null, 2));
  // return 'success';
  const res = {};
  // setTimeout(() => {
  //   return res;
  // }, 1000);
  try {
    const data = await postData(emailData);
    res.success = true;
  } catch (err) {
    res.error = err;
  }
  return res;
};

function buildHtml(data) {
  const p1 = `
      <html>
        <head></head>
        <body>
          <div>
            <p>Hi Roger,</p>
            <p>Booking Enquiry below</p>
            <p>
              ${data.firstname} ${data.lastname}<br />
              ${data.email}<br />
              ${data.phone}<br />
            </p>
            <p>
              Date: ${data.date}<br />
              Trip: ${data.trip}<br />
              Accommodation: ${data.accommodation}<br />
              Anglers: ${data.people}<br />
            </p>
    `;
  let p2 = "";
  for (let angler of data.anglers) {
    p2 +=
      `<p>
        ${angler.firstname} ${angler.lastname}<br />
        ${angler.age}<br />
        Fitness: ${angler.fitness}<br />
        Medical: ${angler.medical}<br />
        Dietery: ${angler.dietery}<br />
        Experience: ${angler.experience}<br />
        Licence: ${angler.licence}<br />
        Rod & Reel: ${angler.rodreel}<br />
        Waders: ${angler.waders}<br />` +
      (angler.waders === "Yes"
        ? `Waders size: ${angler.wadersize}<br />`
        : "") +
      `</p>`;
  }
  const p3 = `
        <p>
          Comments: ${data.comments}<br />
          Terms & Conditions: ${data.terms}<br />
          Health & Safety: ${data.safety}<br />
          RMTPFG waiver: ${data.waiver}<br />
          Photography Release: ${data.photorelease}<br />
        </p>
        <p>Thank you</p>
        <p>--------------------<br />
        rogertompkins.com</p>
      </div>
    </body>
  </html>
  `;

  return p1 + p2 + p3;
}

async function postData(data) {
  const res = await fetch(API_URL, {
    method: "POST",
    body: JSON.stringify(data),
    // headers: {
    //   'Origin': 'http://localhost:5000/',
    // }
  });
  console.log("res", res);
  return res;
}
